import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './Operations.css';

function BinTransfer() {
  const { sku } = useParams();
  const navigate = useNavigate();
  const [bins, setBins] = useState([]);
  const [fromBin, setFromBin] = useState('');
  const [toBin, setToBin] = useState('');
  const [quantity, setQuantity] = useState('');
  const [maxQuantity, setMaxQuantity] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchBins();
  }, [sku]);

  const fetchBins = async () => {
    try {
      const response = await axios.get(`/api/ops/inventory/${sku}`);
      setBins(response.data);
    } catch (error) {
      console.error('Failed to fetch bins:', error);
    }
  };

  const handleFromBinChange = (e) => {
    const binId = e.target.value;
    setFromBin(binId);
    // Compare both as strings to avoid type mismatch
    const bin = bins.find(b => String(b.bin_id) === String(binId));
    if (bin) {
      setMaxQuantity(bin.quantity);
      console.log('Selected bin:', bin, 'Max quantity:', bin.quantity);
    } else {
      setMaxQuantity(0);
      console.log('No bin found for ID:', binId);
    }
  };

  const handleTransfer = async (e) => {
    e.preventDefault();
    setError('');

    // Client-side validation
    const qty = parseInt(quantity);
    if (isNaN(qty) || qty < 1) {
      setError('Please enter a valid quantity');
      return;
    }

    if (maxQuantity > 0 && qty > maxQuantity) {
      setError(`Quantity cannot exceed ${maxQuantity}`);
      return;
    }

    if (!fromBin || !toBin) {
      setError('Please select both source and destination bins');
      return;
    }

    setLoading(true);

    try {
      // Get authenticated user info from session
      const userJson = sessionStorage.getItem('ops_user');
      const user = userJson ? JSON.parse(userJson) : null;
      const userName = user ? `${user.first_name} ${user.last_name}` : 'Mobile User';

      console.log('Sending transfer request:', { sku, from_bin_id: fromBin, to_bin_id: toBin, quantity: qty, transferred_by: userName });

      await axios.post('/api/ops/transfer', {
        sku,
        from_bin_id: fromBin,
        to_bin_id: toBin,
        quantity: qty,
        transferred_by: userName
      });

      alert('Transfer completed successfully!');
      navigate(`/ops/${sku}/inventory`);
    } catch (error) {
      console.error('Transfer error:', error.response?.data);
      setError(error.response?.data?.error || 'Transfer failed');
      setLoading(false);
    }
  };

  return (
    <div className="ops-page">
      <div className="ops-page-header">
        <Link to={`/ops/${sku}`} className="back-button">← Back</Link>
        <h1>Bin Transfer</h1>
        <div className="sku-label">{sku}</div>
      </div>

      <form onSubmit={handleTransfer} className="transfer-form">
        {error && <div className="error-message">{error}</div>}

        <div className="form-group">
          <label htmlFor="fromBin">From Bin</label>
          <select
            id="fromBin"
            value={fromBin}
            onChange={handleFromBinChange}
            required
            className="form-control"
          >
            <option value="">Select source bin</option>
            {bins.map(bin => (
              <option key={bin.bin_id} value={bin.bin_id}>
                {bin.bin_code} (Qty: {bin.quantity})
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label htmlFor="toBin">To Bin</label>
          <input
            type="text"
            id="toBin"
            value={toBin}
            onChange={(e) => setToBin(e.target.value)}
            placeholder="Enter destination bin code"
            required
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label htmlFor="quantity">Quantity</label>
          <input
            type="number"
            id="quantity"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            min="1"
            max={maxQuantity > 0 ? maxQuantity : undefined}
            required
            className="form-control"
          />
          {maxQuantity > 0 && (
            <small className="form-help">Max available: {maxQuantity}</small>
          )}
        </div>

        <button
          type="submit"
          disabled={loading}
          className="submit-button"
        >
          {loading ? 'Processing...' : 'Complete Transfer'}
        </button>
      </form>
    </div>
  );
}

export default BinTransfer;